import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';


export class ClinikoGiveAccessRequestDto extends BaseDto {
    userCode: string;

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor(userCode: string) {
        super();
        this.userCode = userCode;
    }
}


